<style lang="scss">
  @import '../resources/scss/team.scss';
  @import '../resources/scss/header.scss';
</style>

<script lang="ts">
  import type { Team } from '../api/rest/directus-cms/about/models/Team'

  export let team: Team
</script>

{#if team}
  <section id="team">
    <div class="container-fluid bg_secondary_i">
      <div class="container-xxl">
        <h1 class="text-orange mb-4">{team.title}</h1>
        <div class="row text-secondary-orange team-text">
          <div class="col-12">
            {@html team.president_text}
          </div>
          <div class="col-md-6">
            {@html team.left_text}
          </div>
          <div class="col-md-6">
            {@html team.right_text}
          </div>
        </div>
      </div>
    </div>
  </section>
{/if}
